// Constants
import { CD_ZA_LEGAL_ENTITY } from '../Constants/Constants';

interface AffiliateRelatedRecordsData {
    related_legal_entity: string;
    related_customer_name: string;
    related_affiliate_number: string;
    related_affiliate_sf_id: string;
};

export const convertIntoAccountSwitchOptions = (affiliateRelatedRecordsData: AffiliateRelatedRecordsData[]) => {
    const convertedData = affiliateRelatedRecordsData.map((record: AffiliateRelatedRecordsData) => {
        const optionObject = {
            label: record.related_customer_name,
            icon: record.related_legal_entity === CD_ZA_LEGAL_ENTITY ? 'countries/south-africa' : 'countries/united-kingdom',
            affiliateNumber: record.related_affiliate_number,
            legalEntity: record.related_legal_entity,
            value: record.related_affiliate_sf_id
        }
        return optionObject;
    }) ?? [];

    return convertedData;
};